/** `meet` namespace — Swedish (source of truth). PLAN-085 meeting room. */
const meet = {
  disabled: {
    title: 'Videomöten är inte aktiverade',
    description:
      'HUB-videomöten är inte påslagna för din organisation. En administratör kan aktivera dem.',
    back: 'Till projektet',
  },
  loading: 'Ansluter till mötet…',
  reconnecting: 'Återansluter till mötet…',
  ongoing: {
    title: 'Pågående möte',
    live: 'Live',
    reconnecting: 'Återansluter',
    return: 'Tillbaka till mötet',
  },
  leaveProject: {
    title: 'Lämna mötet?',
    description:
      'Du lämnar mötet om du byter projekt. Mötet fortsätter för de andra, och du kan gå med igen från kalendern.',
    cancel: 'Stanna kvar',
    confirm: 'Lämna mötet',
  },
  notFound: {
    title: 'Mötet hittades inte',
    description: 'Länken är felaktig, eller så hör mötet till ett annat projekt.',
    back: 'Till kalendern',
  },
  notConfigured: {
    title: 'Videomöten är inte konfigurerade',
    description: 'Miljön saknar RealtimeKit-inställningar. Kontakta en administratör.',
  },
  prejoin: {
    title: 'Klar att gå med?',
    cameraOff: 'Kameran är av',
    permissionDenied:
      'HUB fick inte tillgång till mikrofon eller kamera. Du kan gå med ändå och slå på dem senare.',
    cameraDenied: 'HUB fick inte tillgång till kameran. Du kan gå med ändå och slå på den senare.',
    microphoneDenied:
      'HUB fick inte tillgång till mikrofonen. Du kan gå med ändå och slå på den senare.',
    microphone: 'Mikrofon',
    camera: 'Kamera',
    join: 'Gå med',
    joining: 'Ansluter…',
    cancel: 'Avbryt',
  },
  waiting: {
    title: 'Mötet har inte börjat än',
    opensIn: 'Du kan gå med om {{time}}',
    openingNow: 'Öppnar nu…',
    retry: 'Försök igen',
    notes: 'Öppna mötesanteckningarna',
  },
  ended: {
    title: 'Mötet är slut',
    host: 'Värden avslutade mötet.',
    idle: 'Mötet avslutades eftersom ingen var kvar.',
    cap: 'Mötet avslutades efter sex timmar.',
    rtk: 'Mötet avslutades.',
    deleted: 'Mötet togs bort.',
    notesPending: 'Mötesanteckningarna skrivs klart…',
    notes: 'Öppna mötesanteckningarna',
    back: 'Till kalendern',
  },
  controls: {
    micOn: 'Stäng av mikrofonen',
    micOff: 'Slå på mikrofonen',
    cameraOn: 'Stäng av kameran',
    cameraOff: 'Slå på kameran',
    shareOn: 'Sluta dela skärm',
    shareOff: 'Dela skärm',
    panelOn: 'Dölj live-panelen',
    panelOff: 'Visa live-panelen',
    participants_one: '{{count}} deltagare',
    participants_other: '{{count}} deltagare',
    leave: 'Lämna',
    end: 'Avsluta mötet',
    micShortcut: 'Tryck M för att slå på/av mikrofonen',
    raiseHand: 'Räck upp handen',
    lowerHand: 'Ta ner handen',
    pauseTranscription: 'Pausa transkriberingen — HUB slutar lyssna',
    resumeTranscription: 'Återuppta transkriberingen',
  },
  endDialog: {
    title: 'Avsluta mötet för alla?',
    description:
      'Alla deltagare kopplas från och HUB skriver klart mötesanteckningarna. Det går inte att ångra.',
    cancel: 'Avbryt',
    confirm: 'Avsluta mötet',
  },
  banner: {
    pausedByHost: 'Transkribering pausad — HUB lyssnar inte',
    pausedByCredits: 'Transkribering pausad — krediterna är slut',
    resume: 'Återuppta',
  },
  participants: {
    title_one: '{{count}} deltagare',
    title_other: '{{count}} deltagare',
    active: 'I mötet',
    connected: 'Ansluten',
    left: 'Har lämnat',
  },
  hands: {
    title_one: '{{count}} räckt hand',
    title_other: '{{count}} räckta händer',
    raised: '{{name}} räcker upp handen',
    lower: 'Sänk',
  },
  devices: {
    microphone: 'Mikrofon',
    camera: 'Kamera',
    choose: 'Välj {{kind}}',
  },
  dock: {
    title_one: '{{count}} deltagare',
    title_other: '{{count}} deltagare',
    speaking: 'Talar',
    handRaised: 'Räcker upp handen',
    collapse: 'Fäll ihop videorutan',
    expand: 'Fäll ut videorutan',
    you: 'Du',
    muted: 'Avstängd mikrofon',
    screenShare: 'Delar skärm',
    expandShare: 'Visa skärmdelningen större',
    closeShare: 'Stäng',
  },
  share: {
    viewing: '{{name}} delar sin skärm',
    zoomIn: 'Zooma in',
    zoomOut: 'Zooma ut',
    fit: 'Anpassa',
    minimize: 'Minimera',
    title: 'Du delar din skärm',
    stop: 'Sluta dela',
  },
  panel: {
    title: 'Live',
    transcript: 'Transkript',
    summary: 'Sammanfattning',
    empty: 'Ingenting sagt än.',
    noSummary: 'Sammanfattningen skrivs efter en minut.',
    decisions: 'Beslut',
    actions: 'Åtgärdspunkter',
  },
  errors: {
    joinFailed: 'Kunde inte gå med i mötet.',
    mediaFailed: 'Kunde inte starta kamera eller mikrofon.',
    microphoneBlocked:
      'Mikrofonen är blockerad — du hörs inte. Kontrollera webbläsarens behörigheter.',
    outOfCredits: 'Krediterna är slut. En administratör kan höja gränsen.',
    retry: 'Försök igen',
  },
}

export default meet
